export default class CopyButton extends React.PureComponent

  constructor: (props) ->
    super(props)

    @state =
      popoverTextType: 'initial' # 'initial' or 'success'
      popoverVisible:  false

    @onClick            = @onClick.bind(this)
    @showInitialPopover = @showInitialPopover.bind(this)
    @hideInitialPopover = @hideInitialPopover.bind(this)
    @hideSuccessPopover = @hideSuccessPopover.bind(this)

  onClick: ->
    if @state.popoverTextType != 'success'
      @props.onClick()

      @showSuccessPopover()

  showInitialPopover: ->
    if @state.popoverTextType != 'success'
      @setState(
        popoverVisible:  true
        popoverTextType: 'initial'
      )

  hideInitialPopover: ->
    if @state.popoverTextType != 'success'
      @setState(popoverVisible: false)

  showSuccessPopover: ->
    @setState(
      popoverVisible:  true
      popoverTextType: 'success'
    )

    setTimeout(@hideSuccessPopover, 2000)

  hideSuccessPopover: ->
    @setState(popoverVisible: false, ->
      setTimeout((=>  @setState(popoverTextType: 'initial')), 300) # enough time for CSS transition
    )

  popoverText: ->
    if @state.popoverTextType == 'initial'
      @props.initialText
    else if @state.popoverTextType == 'success'
      <span>
        { @props.successText }
        &nbsp;
        <i className="fas fa-check"></i>
      </span>

  render: ->
    <div className={@props.className}>
      { @renderButton() }
      { @renderPopover() }
    </div>

  renderButton: ->
    classes = "btn btn-link"
    classes += " d-none" if !@props.buttonVisible

    <button className={classes}
            onClick={@onClick}
            onMouseEnter={@showInitialPopover}
            onMouseLeave={@hideInitialPopover}>
      <i className="far fa-copy"></i>
    </button>

  renderPopover: ->
    classes = "neuro-popover"
    classes += " hidden" if !@state.popoverVisible

    <div className={classes}>
      { @popoverText() }
    </div>
